import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/claimList";

const getClaimList = ({
  luckyDrawUuid,
  status,
  limit = 50,
  skip = 0,
  searchText,
  searchType,
  claimedDateStart,
  claimedDateEnd,
  prizeType,
}) => {
  return new Promise((resolve, reject) => {
    const params = {
      luckyDrawUuid,
      limit,
      skip,
    };

    // Add optional parameters only if they have values
    if (status) params.status = status;
    if (searchText) params.searchText = searchText;
    if (searchType) params.searchType = searchType;
    if (claimedDateStart) params.claimedDateStart = claimedDateStart;
    if (claimedDateEnd) params.claimedDateEnd = claimedDateEnd;
    if (prizeType) params.prizeType = prizeType;

    axios
      .get(endpoint_url, { params })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getClaimList;
